/**
 * Returns true for middle-clicks (button === 1). Right-clicks are excluded to avoid
 * double-counting with onContextMenu.
 */
export const isAuxClick = (e: { button: number }): boolean => {
	return e.button === 1;
};
